import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@ui/components/Badge/Badge'
import { Button } from '@ui/components/Button'

import { useWindowResize } from '@utils/domUtils'

import { SubscriptionRequest } from '@model/TradingPlatformsDto'

import { isSubscriptionTimeInForceImmediate } from './subscriptionUtils'

export const CancelOrProcessingButton = memo(
  ({
    subscriptionRequest,
    scrollToCart,
    onCancel,
  }: {
    onCancel(): void
    subscriptionRequest?: SubscriptionRequest
    scrollToCart?: () => void
  }) => {
    const isMobile = useWindowResize()
    const { t } = useTranslation()
    const isSubscriptionRequestImmediate = isSubscriptionTimeInForceImmediate(subscriptionRequest)

    return isSubscriptionRequestImmediate ? (
      <Badge type='yellow' contrast='low' size='sm'>
        {t('Subscriptions.Processing')}
      </Badge>
    ) : (
      <div className='is-flex is-justify-content-center'>
        <Button.Secondary size={isMobile ? 'md' : 'sm'} onClick={onCancel}>
          {t('Cancel')}
        </Button.Secondary>
        <div className='ml-2'>
          <Button.Primary size={isMobile ? 'md' : 'sm'} onClick={() => scrollToCart?.()}>
            {t('Subscriptions.Go to cart')}
          </Button.Primary>
        </div>
      </div>
    )
  }
)
